import { prettyError, prettyErrorButton, prettyErrorDescription } from 'constants/errors'
import GenericError from 'components/generic-error'
import { ButtonMenu, SpanMenu } from 'theme/header'
import { useEffect, useState } from 'react'
import { useBg } from 'hooks/use-white-bg'

type IFunctionRetry = (code: number) => void

function ErrorView({ code, onRetry, buttonMenu }: { code: number, onRetry?: IFunctionRetry, buttonMenu?: IFunctionRetry }) {

  const [shouldUseWhiteBg] = useState(useBg)

  const handleMenu = () => {
    if (buttonMenu) buttonMenu(code)
  }

  const handleButton = () => {
    if (onRetry) onRetry(code)
  }

  useEffect(() => {
    setTimeout(() => {
      const event = new CustomEvent('background-color', {
        detail: {
          shouldUseWhiteBg: true
        }
      })

      window.dispatchEvent(event)
    }, 200)

    return () => {
      const event = new CustomEvent('background-color', {
        detail: {
          shouldUseWhiteBg
        }
      })

      window.dispatchEvent(event)
    }
  }, [])

  const { title, description, button } = { title: prettyError(code), description: prettyErrorDescription(code), button: prettyErrorButton(code) }

  return (
    <div className="flex justify-center items-center w-full flex-col text-center px-7 flex-1">
      <ButtonMenu
        className="w-24 h-24 p-8 absolute top-0 right-0"
        open={true}
        onClick={handleMenu}
      >
        <SpanMenu open={true} className={`transition block h-0.5 w-8 transform rotate-45 -mb-0.5`} />
        <SpanMenu open={true} className={`transition block h-0.5 w-8 transform -rotate-45 -mb-0.5`} />
      </ButtonMenu>
      <div className="space-y-4 flex-1 flex flex-col items-center justify-center py-7 w-full">
        <GenericError error={title} description={description} buttonText={button} onRetry={handleButton} />
      </div>
    </div>
  )
}

export default ErrorView